/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { h as helper } from '../../_chunks/dep-1461d230.js';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { computed } from '@vue/composition-api';
import isBoolean from 'lodash/isBoolean';
import { usePrefixClass } from '../../hooks/useConfig.js';
import { Checkbox } from '../../checkbox/index.js';
import { getTNode } from '../util.js';
import useItemEvents from './useItemEvents.js';
import '../../config-provider/useConfig.js';
import '../../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../../_chunks/dep-9849f16c.js';
import '../../config-provider/type.js';
import '../../checkbox/group.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/intersection';
import 'lodash/isObject';
import 'lodash/isUndefined';
import '../../checkbox/checkbox.js';
import '../../checkbox/props.js';
import '../../hooks/index.js';
import '../../utils/render-tnode.js';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../hooks/slots.js';
import 'lodash/isArray';
import '../../hooks/useCommonClassName.js';
import '../../hooks/useDefaultValue.js';
import '../../hooks/useDestroyOnClose.js';
import '../../hooks/useElementLazyRender.js';
import '../../_common/js/utils/observe.js';
import '../../hooks/useFormDisabled.js';
import '../../hooks/useGlobalIcon.js';
import '../../hooks/useLazyLoad.js';
import '../../hooks/useResizeObserver.js';
import '../../hooks/useVirtualScrollNew.js';
import '../../hooks/useVModel.js';
import '../../hooks/useImagePreviewUrl.js';
import '../../_common/js/upload/utils.js';
import '../../_common/js/log/log.js';
import '../../checkbox/constants.js';
import '../../checkbox/store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../../checkbox/hooks/useKeyboardEvent.js';
import '../../checkbox/checkbox-group-props.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../checkbox/type.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useRenderLabel(props, context) {
  var classPrefix = usePrefixClass().value;
  var componentName = usePrefixClass("tree").value;
  var _useItemEvents = useItemEvents(props, context),
    handleChange = _useItemEvents.handleChange;
  var renderLabel = function renderLabel(h) {
    var node = props.node,
      treeScope = props.treeScope,
      expandOnClickNode = props.expandOnClickNode;
    var scopedSlots = treeScope.scopedSlots;
    var treeProps = (treeScope === null || treeScope === void 0 ? void 0 : treeScope.treeProps) || {};
    var label = treeProps.label,
      disableCheck = treeProps.disableCheck;
    var checkProps = (treeProps === null || treeProps === void 0 ? void 0 : treeProps.checkProps) || {};
    var labelNode = null;
    if (label === true) {
      if (scopedSlots !== null && scopedSlots !== void 0 && scopedSlots.label) {
        labelNode = scopedSlots.label({
          node: node === null || node === void 0 ? void 0 : node.getModel()
        });
      } else {
        labelNode = node.label || "";
      }
    } else {
      labelNode = getTNode(label, {
        createElement: h,
        node: node
      });
    }
    var labelClasses = ["".concat(componentName, "__label"), _defineProperty({}, "".concat(classPrefix, "-is-active"), node.isActivable() ? node.actived : false)];
    var shouldStopLabelTrigger = computed(function () {
      var _node$children;
      var isNormalBranchNode = Array.isArray(node.children) && ((_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.length) > 0;
      var isLazyLoadChildBranchNode = isBoolean(node.children) && node.children;
      var isBranchNode = isNormalBranchNode || isLazyLoadChildBranchNode;
      return expandOnClickNode && isBranchNode;
    });
    if (node.vmCheckable) {
      var checkboxDisabled = false;
      if (typeof disableCheck === "function") {
        checkboxDisabled = disableCheck(node.getModel());
      } else {
        checkboxDisabled = !!disableCheck;
      }
      if (node.vmIsLocked && !node.vmIsRest) {
        checkboxDisabled = true;
      }
      if (node.isDisabled()) {
        checkboxDisabled = true;
      }
      var itemCheckProps = _objectSpread(_objectSpread({}, checkProps), {}, {
        disabled: checkboxDisabled
      });
      labelNode = h(Checkbox, helper([{
        "class": labelClasses,
        "attrs": {
          "checked": node.checked,
          "indeterminate": node.indeterminate,
          "disabled": node.isDisabled(),
          "name": String(node.value),
          "stopLabelTrigger": shouldStopLabelTrigger.value,
          "ignore": "expand,active"
        },
        "on": {
          "change": handleChange
        }
      }, {
        "props": itemCheckProps
      }]), [labelNode]);
    } else {
      var inner = h("span", {
        "style": "position: relative"
      }, [labelNode]);
      labelNode = node.isActivable() ? h("span", {
        "key": "1",
        "class": labelClasses,
        "attrs": {
          "title": node.label
        }
      }, [inner]) : h("span", {
        "key": "2",
        "class": labelClasses,
        "attrs": {
          "title": node.label
        }
      }, [inner]);
    }
    return labelNode;
  };
  return {
    renderLabel: renderLabel
  };
}

export { useRenderLabel as default };
//# sourceMappingURL=useRenderLabel.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/tree/hooks/useRenderLabel.js
// module id = null
// module chunks = 